module.exports = __webpack_public_path__ + "static/media/zoho_logo.8f370e42.png";